// BottomNavBar.tsx

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faBriefcase,
    faUser,
} from "@awesome.me/kit-f3e20eab48/icons/classic/solid";
// import MapIcon from "../../../assets/icons/map-icon.svg?react";
import "./BottomNavBar.scss";
import { NavLink, useLocation } from "react-router-dom";
import { sendHapticFeedback } from "../../../logic/helpers/world/sendHapticFeedback";

export default function BottomNavBar() {
    const location = useLocation();
    const currentPath = location.pathname;

    const handleNavClick = () => {
        sendHapticFeedback({ type: "medium" });
    };

    return (
        <div
            className={`bottom-navbar ${
                // currentPath === "/map"
                //     ? "map"
                //     : currentPath === "/settings"
                //     ? "settings"
                //     : "home"

                currentPath === "/"
                    ? "home"
                    : currentPath === "/business"
                      ? "business"
                      : currentPath === "/map"
                        ? "map"
                        : currentPath === "/settings"
                          ? "settings"
                          : "home"
            }`}
        >
            <div className="bottom-navbar__content">
                <NavLink
                    to="/"
                    onClick={handleNavClick}
                    className={({ isActive }) =>
                        `bottom-navbar__content__item first ${
                            isActive ? "active" : ""
                        }`
                    }
                >
                    <FontAwesomeIcon icon={faHome} />
                </NavLink>
                <NavLink
                    to="/business"
                    onClick={handleNavClick}
                    className={({ isActive }) =>
                        `bottom-navbar__content__item second ${
                            isActive ? "active" : ""
                        }`
                    }
                >
                    <FontAwesomeIcon icon={faBriefcase} />

                    {/* <div className="business-badge">
                        <div className="business-badge__inner">
                            <p>NEW!</p>
                        </div>
                    </div> */}
                </NavLink>
                {/* <NavLink
                    to="/map"
                    onClick={handleNavClick}
                    className={({ isActive }) =>
                        `bottom-navbar__content__item third ${
                            isActive ? "active" : ""
                        }`
                    }
                >
                    <MapIcon />
                </NavLink> */}
                <NavLink
                    to="/settings"
                    onClick={handleNavClick}
                    className={({ isActive }) =>
                        `bottom-navbar__content__item fourth ${
                            isActive ? "active" : ""
                        }`
                    }
                >
                    <FontAwesomeIcon icon={faUser} />
                </NavLink>
            </div>
        </div>
    );
}
